import {Injectable} from '@angular/core';
import {FormModel, FormState} from '../../components/form/models';
import {FormStateOptionsModel} from './form-state-options.model';

@Injectable({ providedIn: 'root' })
export class StatesFormService {
  constructor() {
  }
  /**
   * Le libellé d'un état formulaire
   * @param {FormState} state
   */
  getStateLabel(state: FormState) {
    const stateMap: Map<FormState, string> = new Map<FormState, string>([
      [FormState.draft, 'En construction'],
      [FormState.published, 'En ligne'],
      [FormState.offline, 'Hors ligne'],
      [FormState.archived, 'Archivé']
    ]);
    return stateMap.get(state) || '';
  }
  /**
   * L'icone / couleur / libellé d'un état formulaire
   * @param {FormState} state
   */
  getStateModel(state: FormState): FormStateOptionsModel {
    const stateMap: Map<FormState, FormStateOptionsModel> = new Map<FormState, FormStateOptionsModel>([
      [FormState.draft,
        <FormStateOptionsModel>{order: 0, icon: 'edit', color: 'blue', state: FormState.draft, label: this.getStateLabel(state)}],
      [FormState.published,
        <FormStateOptionsModel>{order: 3, icon: 'done', color: 'green', state: FormState.published, label: this.getStateLabel(state)}],
      [FormState.offline,
        <FormStateOptionsModel>{order: 5, icon: 'highlight_off', color: 'red', state: FormState.offline, label: this.getStateLabel(state)}],
      [FormState.archived,
        <FormStateOptionsModel>{order: 7, icon: 'archive', color: 'orange', state: FormState.archived, label: this.getStateLabel(state)}],
    ]);
    return stateMap.get(state) || null;
  }

  /**
   * Liste des états possible selon l'état du formulaire
   * En construction => En ligne
   * En ligne => Hors ligne
   * Hors ligne => En ligne
   * @param {FormState} state
   */
  getStateModelsAvailableFormState(state: FormState): FormStateOptionsModel[] {
    let statesOptions: FormStateOptionsModel[] = [];
    switch (state) {
      case FormState.draft:
        statesOptions = [this.getStateModel(FormState.draft), this.getStateModel(FormState.published)];
        break;
      case FormState.published:
        statesOptions = [this.getStateModel(FormState.published), this.getStateModel(FormState.offline)];
        break;
      case FormState.offline:
        statesOptions = [this.getStateModel(FormState.offline), this.getStateModel(FormState.published)];
    }
    return statesOptions;
  }
  /**
   * Liste de tous les états possibles d'un formulaire avec :
   * - son libellé
   * - son icon (option)
   * - sa couleur (option)
   * - son ordre (option)
   * @param {FormState[]} excludes : états à exclure de la liste, optionnel
   */
  getStateModels(excludes: FormState[] = []): FormStateOptionsModel[] {
    const statesOptions: FormStateOptionsModel[] = [];
    Object.entries(FormState).forEach(_state => {
      if (Number.isInteger(_state[1]) && ! excludes.includes(Number(_state[1]))) {
        statesOptions.push(this.getStateModel(Number(_state[1])));
      }
    });
    statesOptions.sort((_stateA, _stateB) => (_stateA.order > _stateB.order) ? 1 : ((_stateB.order > _stateA.order) ? -1 : 0));
    return statesOptions;
  }
  /**
   * Etat du formulaire
   * @param {FormModel} formulaire
   */
  getStateForm(formulaire: FormModel): string {
    return this.getStateLabel(formulaire.state);
  }
}
